<script>
import Mgr from "./../../services/securityService";

const mapMutations = window.Vuex.mapMutations;
export default {
  name: "SilentRenewCallback",
  data() {
    return {
      mgr: new Mgr(this.$store.state.config.configurationData.common_module)
    };
  },
  mounted() {
    const self = this;
    try {
      this.mgr.silentRenewCallback();
    } catch (e) {
      self.setAuthErrors(e.message);
      self.mgr.signOut();
    }
  },
  methods: {
    ...mapMutations({
      setAuthErrors: "auth/setAuthErrors"
    })
  }
};
</script>
